// This store is used to ensure always showing a loading spinner when navigating between routes

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoadingRouteStore = defineStore('loading', () => {
  const isLoading = ref(false)

  function show() {
    isLoading.value = true
  }

  function hide() {
    isLoading.value = false
  }

  return {
    isLoading,
    show,
    hide,
  }
})
